// extracted by mini-css-extract-plugin
export default {"body":"CallListContainer_body__WMApc","gridheader":"CallListContainer_gridheader__FjR+w","gridfooter":"CallListContainer_gridfooter__hCPze","right":"CallListContainer_right__ZJLLe"};